module.exports = __webpack_public_path__ + "img/woocommerce.cee096e7.svg";